import api from '../../../services/api';

export const saveToken = (payload) => api.post('/smm/auth/token', payload).then(r => r.data);
export const authorize = (platform) => api.get(`/smm/auth/${platform}/authorize`).then(r => r.data);
export const refreshToken = (payload) => api.post('/smm/auth/refresh', payload).then(r => r.data);
